/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: 02cd6e6c735b
 */

import * as z from "zod";
import { ApiError, ApiError$zodSchema } from "./apierror.js";
import {
  TransformationListResponse,
  TransformationListResponse$zodSchema,
} from "./transformationlistresponse.js";

export type ListTransformationsGlobals = { cloud_name?: string | undefined };

export const ListTransformationsGlobals$zodSchema: z.ZodType<
  ListTransformationsGlobals
> = z.object({
  cloud_name: z.string().describe("The cloud name of your product environment.")
    .optional(),
});

export type ListTransformationsRequest = {
  named?: boolean | undefined;
  max_results?: number | undefined;
  next_cursor?: string | undefined;
};

export const ListTransformationsRequest$zodSchema: z.ZodType<
  ListTransformationsRequest
> = z.object({
  max_results: z.int().default(10).describe(
    "The maximum number of results to return. Default is 10.",
  ),
  named: z.boolean().describe(
    "Whether to return only named (`true`) or unnamed (`false`) transformations. If this parameter isn't included, both named and unnamed transformations will be returned.",
  ).optional(),
  next_cursor: z.string().describe(
    "The cursor for pagination. Use the next_cursor value from a previous response to get the next page of results.",
  ).optional(),
});

export type ListTransformationsResponse = ApiError | TransformationListResponse;

export const ListTransformationsResponse$zodSchema: z.ZodType<
  ListTransformationsResponse
> = z.union([
  ApiError$zodSchema,
  TransformationListResponse$zodSchema,
]);
